<template>
    <div>
        <ul class="navbar-nav sidebar color-black bg-gray-900 sidebar-dark accordion" :class="{ 'toggled' : sidebarToggled }" id="accordionSidebar">
            <router-link class="sidebar-brand d-flex align-items-center justify-content-center" to="/">
                <div class="sidebar-brand-icon">
                    <img src="/assets/images/logo.svg" title="Logo" />
                </div>
                <div class="sidebar-brand-text mx-3">
                    <h2>Gazeto Administration</h2>
                </div>
            </router-link>
            <hr class="sidebar-divider my-0">
            <li class="nav-item active">
                <router-link class="nav-link" to="/admin">
                    <span>Dashboard</span>
                </router-link>
            </li>
            <hr class="sidebar-divider">
            <div class="sidebar-heading">Application</div>
            <li class="nav-item">
                <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapse-categories" aria-expanded="true" aria-controls="collapse-categories">
                    <span>Categories</span>
                </a>
                <div id="collapse-categories" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                    <div class="bg-white py-2 collapse-inner rounded">
                        <router-link class="collapse-item" to="/admin/categories">Categories</router-link>
                        <router-link class="collapse-item" to="/admin/categories/add">Create Category</router-link>
                        <router-link class="collapse-item" to="/admin/categories/reorder">Reorder Category</router-link>
                    
                    </div>
                </div>
            </li>
            <li class="nav-item">
                <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapse-doctors" aria-expanded="true" aria-controls="collapse-doctors">
                    <span>Doctors</span>
                </a>
                <div id="collapse-doctors" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                    <div class="bg-white py-2 collapse-inner rounded">
                        <router-link class="collapse-item" to="/admin/doctors">Doctors</router-link>
                        <router-link class="collapse-item" to="/admin/doctors/register">Register Doctor</router-link>
                        <router-link class="collapse-item" to="/admin/membership-orders">Membership Orders</router-link>
                    </div>
                </div>
            </li>
            <li class="nav-item">
                <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapse-test-types" aria-expanded="true" aria-controls="collapse-test-types">
                    <span>Test Types</span>
                </a>
                <div id="collapse-test-types" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                    <div class="bg-white py-2 collapse-inner rounded">
                        <router-link class="collapse-item" to="/admin/test-types">Test Types</router-link>
                        <router-link class="collapse-item" to="/admin/test-types/add">Create Test Type</router-link>
                        <router-link class="collapse-item" to="/admin/test-types/reorder">Reorder Test Type</router-link>
                    </div>
                </div>
            </li>
            <hr class="sidebar-divider">
            <div class="sidebar-heading">
                Settings
            </div>
            <li class="nav-item">
                <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapse-languages" aria-expanded="true" aria-controls="collapse-languages">
                    <span>Languages</span>
                </a>
                <div id="collapse-languages" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                    <div class="bg-white py-2 collapse-inner rounded">
                        <router-link class="collapse-item" to="/admin/languages">Languages</router-link>
                        <router-link class="collapse-item" to="/admin/languages/add">Add Language</router-link>
                        <router-link class="collapse-item" to="/admin/translation-keys">Translation Keys</router-link>
                        <router-link class="collapse-item" to="/admin/translation-keys/add">Add Translation Key</router-link>
                    </div>
                </div>
            </li>
            <hr class="sidebar-divider">
            <div class="text-center d-none d-md-inline">
                <button id="toggle-btn" @click="toggleSidebar" class="rounded-circle border-0"><icon :icon="(sidebarToggled ? 'arrow-circle-right' : 'arrow-circle-left')"/></button>
            </div>

        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            sidebarToggled: false
        }
    },
    methods: {
        toggleSidebar: function() {
            this.sidebarToggled = !this.sidebarToggled;
        }
    }
}
</script>
<style lang="scss" scoped>
    #toggle-btn {
        background: transparent;
        padding: 0px;
        font-size: 30px;
        color: white;
    }
    #collapse-test-types {
        white-space: normal;
    }
</style>